import { render, staticRenderFns } from "./RefundRequestDetailsCollapsibleSection.vue?vue&type=template&id=6525e82e&scoped=true&"
import script from "./RefundRequestDetailsCollapsibleSection.vue?vue&type=script&lang=js&"
export * from "./RefundRequestDetailsCollapsibleSection.vue?vue&type=script&lang=js&"
import style0 from "./RefundRequestDetailsCollapsibleSection.vue?vue&type=style&index=0&id=6525e82e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6525e82e",
  null
  
)

export default component.exports